import {createSlice} from '@reduxjs/toolkit'
import {HoteleriaModel} from '../../models'

export const EmptyHoteleriaState: HoteleriaModel = {
  showPanel: false,
  tabs: [
    {
      id: 1,
      title: 'Inicio',
      content: {
        headerPanel: '',
        detailPanel: '',
      },
      showPanel: false,
      closable: false,
      submenu: 'start',
    },
  ],
  menu: [],
  currentTab: 0,
}

export const hoteleriaSlice = createSlice({
  name: 'hoteleria',
  initialState: EmptyHoteleriaState,
  reducers: {
    addTabAction: (state, action) => {
      return {...state, tabs: [...state.tabs, action.payload]}
    },
    deleteTabAction: (state, action) => {
      return {...state, tabs: action.payload}
    },
    changeTabAction: (state, action) => {
      return {...state, currentTab: action.payload}
    },
    setCurrentTabItemAction: (state, action) => {
      return {
        ...state,
        tabs: state.tabs.map((tab, idx) =>
          idx === state.currentTab ? {...tab, ...action.payload} : tab
        ),
      }
    },
    setMenuFromApi: (state, action) => {
      return {...state, menu: action.payload}
    },
    resetHoteleria: () => {
      return EmptyHoteleriaState
    },
  },
})

export const {
  resetHoteleria,
  addTabAction,
  deleteTabAction,
  changeTabAction,
  setCurrentTabItemAction,
  setMenuFromApi,
} = hoteleriaSlice.actions

export default hoteleriaSlice.reducer
